import { useParams, useSearchParams, Link } from "react-router-dom";
import ChatPanel from "@/components/ChatPanel";

// -----------------------------------------------------------------------
// ChatClientPage — dedicated /chat/:bookingId page for paid clients. The
// admin sends this link (with ?t=<signed token>) via WhatsApp so the
// client can join Astro-Connect on any device via their Gmail session or
// via the token in the URL.
// -----------------------------------------------------------------------
export default function ChatClientPage() {
  const { bookingId } = useParams();
  const [params] = useSearchParams();
  const token = params.get("t") || "";

  return (
    <div className="min-h-screen bg-[#0A1428] text-[#E9E4D0] px-4 sm:px-8 py-6">
      <header className="max-w-3xl mx-auto flex items-center justify-between mb-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.4em] text-[#D4AF37] font-mono">
            Astromeet Telugu · Astro-Connect
          </div>
          <div className="font-heading text-2xl">Your paid chat room</div>
        </div>
        <Link to="/" className="border border-[#2A3555] text-[#8B99B0] hover:text-[#D4AF37] hover:border-[#D4AF37]/40 rounded-sm px-3 py-2 text-xs uppercase tracking-widest font-mono">
          Home
        </Link>
      </header>
      <div className="max-w-3xl mx-auto">
        <ChatPanel bookingId={bookingId} token={token}
                    title={`Booking ${bookingId}`} />
      </div>
      <div className="max-w-3xl mx-auto mt-3 text-[10px] font-mono text-[#8B99B0] text-center">
        This link is signed for 7 days. If you're logged in with Gmail, your session is used
        instead. Do not share this link — it is your private consultation room.
      </div>
    </div>
  );
}
